import { Title, TitleProps } from '@mantine/core';

type Props = TitleProps;

function Caption(props: Props) {
  return <Title fz={12} fs="normal" fw={400} {...props} />;
}

export default Caption;
